import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';
import AssetService from '../../Services/AssetService';
import ExecuteCommandModalDisplay from './ExecuteCommandModalDisplay';

export default class ExecuteCommandModalContainer extends Component {
  static propTypes = {
    asset: PropTypes.object,
    toggleModal: PropTypes.func,
    toggleCommandExecuted: PropTypes.func,
  };

  static defaultProps = {
    asset: { gtemplate: { name: '' } },
  };

  state = {
    asset: this.parseAssetProps(),
    commands: [],
    error: '',
    executeRequestPending: false,
    jobParameter: '',
    selectedCommand: {},
    selectedButton: '',
  };

  assetService = new AssetService();
  source = CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  parseAssetProps() {
    const { asset } = this.props;
    const _id = asset?._id ?? '';
    const orgID = asset?.orgID ?? '';
    const nickname = asset?.nickname ?? '';
    const gtemplate = asset?.gtemplate ?? '';
    const commands = gtemplate?.commands ?? [];
    const gtemplateID = asset?.gtemplateID ?? '';
    return {
      _id,
      gtemplateID,
      orgID,
      nickname,
      gtemplate,
      commands,
    };
  }

  handleExecuteCommandConfirm = async (e) => {
    e.preventDefault();
    this.setState({ executeRequestPending: true });

    try {
      const {
        asset: { _id: assetID },
        jobParameter,
        selectedCommand,
      } = this.state;

      const body = jobParameter ? { jobParameters: [jobParameter] } : {};
      await this.assetService.executeAssetCommand(
        assetID,
        { commandID: selectedCommand._id },
        body,
        this.source.token
      );
      this.props.toggleCommandExecuted();
      this.setState({
        executeRequestPending: false,
        jobParameter: '',
        selectedButton: '',
        selectedCommand: {},
      });
    } catch (err) {
      if (!isCancel(err)) {
        const error = err.response?.data?.message ?? err.message;
        this.setState({
          error,
          executeRequestPending: false,
          jobParameter: '',
          selectedButton: '',
          selectedCommand: {},
        });
      }
    }
    this.props.toggleModal();
  };

  handleExecuteCommand = () => {
    const { asset } = this.state;
    this.setState({
      commands: asset.commands,
      selectedButton: this.state.selectedCommand._id,
    });
  };

  handleCancelCommand = () => {
    this.setState({ selectedButton: '' });
  };

  onCommandButtonClick = (selectedCommand) => {
    if (this.state.selectedCommand._id === selectedCommand._id) {
      this.setState({ selectedCommand: {}, selectedButton: '' });
    } else {
      this.setState({ selectedCommand, jobParameter: '' });
    }
  };

  handleJobParameterInput = ({ target: { value: jobParameter } }) => {
    this.setState({ jobParameter });
  };

  render() {
    const {
      asset: { nickname, commands, gtemplateID },
      error,
      executeRequestPending,
      jobParameter,
      selectedButton,
      selectedCommand,
    } = this.state;
    return (
      <ExecuteCommandModalDisplay
        {...this.props}
        commands={commands}
        error={error}
        executeRequestPending={executeRequestPending}
        gtemplateID={gtemplateID}
        handleCancelCommand={this.handleCancelCommand}
        handleExecuteCommand={this.handleExecuteCommand}
        handleExecuteCommandConfirm={this.handleExecuteCommandConfirm}
        handleJobParameterInput={this.handleJobParameterInput}
        handlePropUpdate={this.handlePropUpdate}
        jobParameter={jobParameter}
        nickname={nickname}
        onCommandButtonClick={this.onCommandButtonClick}
        selectedButton={selectedButton}
        selectedCommand={selectedCommand}
      />
    );
  }
}
